<template>
  <section class="u-main">
    <v-card class="u-card-profile">
      <div class="u-grid-profile-info">
        <div class="u-profile-row-2">
          <img :src="this['user/user'].avatar || 'https://lh4.googleusercontent.com/-03EW-FpeRBE/AAAAAAAAAAI/AAAAAAAAAAA/ZYNO4RH0oOo/s228-p/photo.jpg'" alt="username" class="u-profile-pic">
        </div>
        <div>
          <p class="u-sub-head">Name</p>
          <p class="u-head">{{ this['user/user'].name || ""}}</p>
        </div>
        <div>
          <p class="u-sub-head">Email</p>
          <p class="u-head">{{ this['user/user'].email || ""}}</p>
        </div>
        <div>
          <p class="u-sub-head">Phone</p>
          <p class="u-head">{{ this['user/user'].phone || "NOT FOUND"}}</p>
        </div>
        <div class="u-profile-col-3 mt-3">
          <p class="u-sub-head">You Can Change Your Profile Picture On Gravatar</p>
          <v-btn small round depressed color="primary" class="ml-0" href="https://en.gravatar.com" target="_blank" rel="nofollow">Go To Gravatar</v-btn>
        </div>
      </div>
    </v-card>
    <v-card class="u-card-update">
      <div class="u-grid-update profilebox">
        <div>
          <div class="u-update-box">
            <div>
              <v-text-field label="FULL NAME" v-model="user.name"/>
            </div>
            <div>
              <v-text-field label="EMAIL" v-model="user.email" />
            </div>
            <div>
              <v-text-field label="PHONE NUMBER" v-model="user.phone"/>
            </div>
            <div>
              <v-btn round depressed block color="primary" @click="updateProfile(user)">Update Profile</v-btn>
            </div>
          </div>
        </div>
      </div>
    </v-card>
    <v-card class="u-card-update">
      <div class="u-grid-update">
        <div>
          <div class="u-update-box">
            <p class="u-head-update">Change Password</p>
            <p class="u-sub-head-update mb-4">Password Must Contain</p>
            <p class="u-head-update-txt">At least 6 characters</p>
            <p class="u-head-update-txt">At least 1 upper case letter (A - Z)</p>
            <p class="u-head-update-txt">At least 1 lower case letter (a - z)</p>
            <p class="u-head-update-txt">At least 1 number (0 - 9)</p>
          </div>
        </div>
        <div>
          <v-form v-model="valid" @submit="changePassword">
            <div class="u-update-box">
              <div>
              <div>
                <v-text-field
                 :rules="newPasswordRules"
                 label="NEW PASSWORD" 
                 type="password" 
                 v-model="password.new" />
              </div>
              <div>
                <v-text-field
                :rules="confirmPasswordRules"
                label="REPEAT PASSWORD" 
                type="password" 
                v-model="password.confirm" />
              </div>
                <v-text-field 
                  :rules="passwordRules"
                  label="CURRENT PASSWORD" 
                  type="password" 
                  v-model="password.old" />
              </div>
              <div>
                <v-btn :disabled="!valid" round depressed block color="primary" type="submit">Update Password</v-btn>
              </div>
            </div>
          </v-form>
        </div>
      </div>
    </v-card>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      user: {
        name: "",
        email: "",
        phone: ""
      },
      valid: false,
      password: {
        old: "",
        new: "",
        confirm: ""
      },
      passwordRules: [
        v => !!v || "Password is required.",
        v =>
          v !== this.password.new ||
          "Password must not equal to the new Password."
      ],
      newPasswordRules: [
        v => !!v || "New Password is required.",
        v => v.length > 6 || "New Password must be greater than 6 characters.",
        v => /[A-Z]/.test(v) || "New Password must have on upper case letter.",
        v => /[a-z]/.test(v) || "New Password must have one lower case letter.",
        v => /[0-9]/.test(v) || "New Password must have one number.",
        v =>
          v !== this.password.old ||
          "New Password must not equal to the old Password."
      ],
      confirmPasswordRules: [
        v => !!v || "Confirm Password is required.",
        v =>
          v === this.password.new ||
          "Confirm Password must match the New Password.",
        v =>
          v !== this.password.old ||
          "New Password must not equal to the old Password."
      ]
    };
  },
  computed: {
    ...mapGetters(["user/user"])
  },
  methods: {
    async changePassword(e) {
      await e.preventDefault();
      await this.$store.dispatch("user/changePassword", this.password);
    },
    async updateProfile({ company, ...obj }) {
      let variables = {};
      Object.keys(obj).forEach(field => {
        if (this["user/user"][field] !== obj[field]) {
          variables[field] = obj[field];
        }
      });
      await this.$store.dispatch("user/updateAccount", variables);
    }
  },
  mounted() {
    this.user = JSON.parse(JSON.stringify(this["user/user"]));
    this.$watch(
      () => this["user/user"],
      () => {
        this.user = JSON.parse(JSON.stringify(this["user/user"]));
      }
    );
  }
};
</script>


<style lang="stylus" scoped>
@import '../assets/stylus/User.styl';

.u-grid-update.profilebox {
  grid-template-columns: repeat(1, 1fr);
}

.profilebox > div > .u-update-box {
  width: 75%;
}
</style>
